import { render } from "./ArchiveIcon.vue?vue&type=template&id=af4b8530"
const script = {}

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__